import { MessageCircle, MapPin } from "lucide-react";
import { Logo } from "./Shared";
import { NAV_LINKS, waLink } from "../../lib/site";

export const Footer = () => (
  <footer className="relative bg-charcoal border-t border-white/10 pt-20 pb-10" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid md:grid-cols-3 gap-12 pb-16 border-b border-white/10">
        <div>
          <Logo />
          <p className="mt-6 text-white/50 text-sm leading-relaxed max-w-xs">
            <span className="text-white/80">Upper Class Chauffeurs</span> — London's discreet, safe and reliable
            private chauffeur service. Latest-model vehicles, master drivers, from £99.
          </p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-booking-button"
            className="mt-6 inline-flex items-center gap-2 text-gold hover:text-gold-light transition-colors text-sm tracking-wide"
          >
            <MessageCircle size={16} /> Make a Booking
          </a>
        </div>

        <div>
          <span className="text-[0.65rem] uppercase tracking-[0.3em] text-white/40">Navigate</span>
          <ul className="mt-6 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-white/60 hover:text-gold transition-colors text-sm"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <span className="text-[0.65rem] uppercase tracking-[0.3em] text-white/40">Visit Us</span>
          <p className="mt-6 flex items-start gap-3 text-white/60 text-sm leading-relaxed">
            <MapPin size={18} className="text-gold mt-0.5 shrink-0" />
            85 High Street, Stanwell,
            <br />
            Staines-Upon-Thames,
            <br />
            England, TW19 7LJ
          </p>
          <a href="tel:+447539889920" className="mt-4 block text-white/60 hover:text-gold transition-colors text-sm" data-testid="footer-phone">
            +44 7539 889920
          </a>
        </div>
      </div>

      <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-white/35 text-xs">
        <p>© {new Date().getFullYear()} Upper Class Chauffeurs. All rights reserved.</p>
        <p className="uppercase tracking-[0.3em]">Safe · Reliable · Discreet</p>
      </div>
    </div>
  </footer>
);
